// assets/infinite-scroll.js
// Progressive enhancement for collection pagination: appends the next page of
// products in place of numbered pagination. Requires `data-infinite-scroll`
// on the collection wrapper and `data-infinite-scroll-container` on the
// <product-list> that receives new items (see sections/main-collection.liquid).
(() => {
  function initInfiniteScroll(root) {
    if (root.dataset.infiniteScrollInitialized) return;

    const container = root.querySelector('[data-infinite-scroll-container]');
    const paginationNav = root.querySelector('.collection__pagination');
    if (!container || !paginationNav) return;

    const shopifySection = root.closest('.shopify-section');
    if (!shopifySection) return;

    let nextLink = paginationNav.querySelector("a[rel='next']");
    if (!nextLink) return;

    root.dataset.infiniteScrollInitialized = 'true';

    const resultsWrapper = root.querySelector('.collection__results') || container;
    let loading = false;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading && nextLink) {
        loadNextPage();
      }
    }, { rootMargin: '600px 0px' });

    observer.observe(paginationNav);

    async function loadNextPage() {
      loading = true;
      resultsWrapper.classList.add('is-loading');

      const url = new URL(nextLink.href, window.location.origin);
      url.searchParams.set('section_id', shopifySection.id.replace('shopify-section-', ''));

      try {
        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error(`Infinite scroll request failed with status ${response.status}`);
        }

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const newContainer = doc.querySelector('[data-infinite-scroll-container]');

        if (newContainer) {
          container.append(...newContainer.childNodes);
        }

        const newNextLink = doc.querySelector(".collection__pagination a[rel='next']");

        if (newNextLink) {
          nextLink = newNextLink;
          const historyUrl = new URL(nextLink.href, window.location.origin);
          history.replaceState(history.state, '', `${historyUrl.pathname}${historyUrl.search}`);
        } else {
          nextLink = null;
          observer.disconnect();
          paginationNav.remove();
        }
      } catch (error) {
        console.error(error);
        nextLink = null;
        observer.disconnect();
      } finally {
        loading = false;
        resultsWrapper.classList.remove('is-loading');
      }
    }
  }

  function init(scope) {
    scope.querySelectorAll('[data-infinite-scroll]').forEach(initInfiniteScroll);
  }

  init(document);

  // Impact's facet/sort filtering replaces the section's children in place
  // (see facet:update handling in theme.js) rather than dispatching a load
  // event, so watch for that swap and re-initialize on the fresh markup.
  document.querySelectorAll('.shopify-section').forEach((shopifySection) => {
    if (!shopifySection.querySelector('[data-infinite-scroll]')) return;

    new MutationObserver(() => init(shopifySection)).observe(shopifySection, { childList: true });
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
